import { ReactNode } from 'react';
import create from 'zustand';

export interface ModalStoreType {
  modalComponent?: ReactNode;
  setModalComponent: (node: ReactNode) => void;
}

export const useModalStore = create<ModalStoreType>(set => ({
  modalComponent: null,
  setModalComponent: node => set({ modalComponent: node }),
}));
